import React, { useState } from 'react';

function Iletisim() {
  const [form, setForm] = useState({ isim: '', telefon: '', mesaj: '' });

  // Akıllı Etiket Tıklama Motoru
  const handleTagClick = (tag) => {
    setForm((prev) => ({
      ...prev,
      mesaj: prev.mesaj ? `${prev.mesaj} - ${tag}` : tag // Mevcut mesajın yanına ekler
    }));
  };

  const handleWhatsAppGonder = (e) => {
    e.preventDefault();
    const telefonNumarasi = "905305090631";
    const whatsappMetni = `Merhaba Demir Grup, ben ${form.isim}.\n\nİletişim Numaram: ${form.telefon}\n\nMesajım: ${form.mesaj}`;
    
    window.open(`https://wa.me/${telefonNumarasi}?text=${encodeURIComponent(whatsappMetni)}`, '_blank');
  };

  return (
    <div className="iletisim-page">
      
      <div className="iletisim-header">
        <h1>Projenizi Konuşalım</h1>
        <p>Güvenlik ve altyapı ihtiyaçlarınız için uzman mühendislerimizle hemen iletişime geçin.</p>
      </div>

      <div className="iletisim-container">
        
        {/* SOL TARAF: Eşit Boyutlu Kartlar */}
        <div className="iletisim-cards">
          <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.4215266857644!2d32.57143961530962!3d39.95465947942171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d33b003a0b3b4f%3A0x7d00f71932158888!2sMalazgirt%2C%20Buhara%20Cd.%2071%2FC%2C%2006930%20Sincan%2FAnkara!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str" target="_blank" rel="noopener noreferrer" className="vip-contact-card clickable-card">
            <div className="card-icon">📍</div>
            <div className="card-info">
              <h3>Merkez Ofis</h3>
              <p>Malazgirt Mah. Buhara Cad.</p>
              <p>71/C Sincan / ANKARA</p>
            </div>
          </a>

          <a href="tel:+905305090631" className="vip-contact-card clickable-card">
            <div className="card-icon">📞</div>
            <div className="card-info">
              <h3>Hızlı İletişim</h3>
              <p>0530 509 06 31</p>
              <p>0545 416 71 41</p>
            </div>
          </a>

          <a href="mailto:ddemirgrup@gmail.com" className="vip-contact-card clickable-card">
            <div className="card-icon">✉️</div>
            <div className="card-info">
              <h3>E-Posta Adresi</h3>
              <p>ddemirgrup@gmail.com</p>
            </div>
          </a>
        </div>

        {/* SAĞ TARAF: VIP Proje Formu ve Lüks Özellikler */}
        <div className="iletisim-form-wrapper">
          
          <div className="live-status">
            <div className="pulse-dot"></div> Müşteri Hizmetleri Aktif
          </div>

          <div className="form-title-area">
            <h2>VIP Teklif İste</h2>
            <p>Hızlı teklif için projenizle ilgili detayları seçin veya yazın.</p>
          </div>
          
          <form onSubmit={handleWhatsAppGonder} className="vip-form">
            <input 
              type="text" 
              placeholder="Adınız Soyadınız" 
              required 
              value={form.isim}
              onChange={(e) => setForm({...form, isim: e.target.value})} 
            />
            <input 
              type="tel" 
              placeholder="Telefon Numaranız" 
              required 
              value={form.telefon}
              onChange={(e) => setForm({...form, telefon: e.target.value})} 
            />
            <textarea 
              placeholder="Proje Detayları veya Mesajınız..." 
              required 
              value={form.mesaj} // State'e bağladık ki etiketler tıklandıkça buraya dolsun
              onChange={(e) => setForm({...form, mesaj: e.target.value})} 
            ></textarea>
            
            <button type="submit" className="wa-submit-btn">
              <span className="wa-icon">💬</span> WhatsApp'tan Teklif Al 🚀
            </button>
          </form>
        </div>

      </div>

      <div className="map-container">
        <iframe 
          title="Demir Grup Konum"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.4215266857644!2d32.57143961530962!3d39.95465947942171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d33b003a0b3b4f%3A0x7d00f71932158888!2sMalazgirt%2C%20Buhara%20Cd.%2071%2FC%2C%2006930%20Sincan%2FAnkara!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
          width="100%" 
          height="450" 
          style={{border:0}} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          className="dark-map"
        ></iframe>
      </div>

    </div>
  );
}

export default Iletisim;